// extracted by mini-css-extract-plugin
export default {"days":"Kz8KKi","day":"A9i6Hy","empty":"n5k2lY","mobileFontSize":"rUrYa6"};